<template>
	<div>
		<v-data-table
				:headers="headers"
				:page.sync="page"
				:items="items"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				class="equipmentTable"
				:items-per-page="getItemsPerPage"
				@page-count="pageCount = $event"
				hide-default-footer
				hide-default-header
				hide-default-body
				fixed-header
		>
			<template v-slot:header="{ props: { headers } }">
				<thead>
				<tr>
					<th
							v-for="(item, index) in headers"
							:class="[{'filter-active': filterClasses[item.value]}, {'dense': item.dense}]"
							:key="index"
							class="wh_w"
							:id="'container-'+item.value"
					>
						<div class="filterIcons">
							<sort-btn
									:sortDesc="sortDesc"
									:sortBy="sortBy"
									:data-sort="item.value"
									@updateToggleOrder="toggleOrder"
							></sort-btn>
							<span class="headText">
                                {{ item.text }}
                            </span>
							<filter-drop-down v-if="item.func" :item="item">
								<filter-table
										@change-sort="changeSort"
										@create-refresh="createRefresh"
										@filter-created="filterCreated"
										@updateFilterListAll="onFilteredAll(item)"
										:data-filter="filter[item.value]"
										:type-filter="item.model"
										:model-filter="item.value"
										:filter-update="filterUpdate"
										:is-disabled="filterPreloader"
										:isRefresh="isRefresh"
										:uniqId="uniqId"
								></filter-table>
							</filter-drop-down>
						</div>
					</th>
					<th></th>
				</tr>
				</thead>
			</template>
			<template v-slot:body="{ items }">
				<tbody>
				<template v-for="(item, idx) in items">
					<table-tr
							:item="item"
							:key="item.id"
							:idx="idx"
							:checkClasses="checkClasses"
							@updateEdit="onEdit"
							:getPermissionAction="getPermissionAction"
							@updateRemoveItem="onRemoveItem"
					></table-tr>
				</template>
				</tbody>
			</template>
		</v-data-table>
		<pagination
				v-if="items.length"
				:length="items.length"
				:pageCount="pageCount"
				:itemsPerPage="itemsPerPage"
				:page="page"
				:isRefresh="isRefresh"
				:isRefreshPage="isRefreshPage"
				:pages="pages"
				@updatePagination="onPagination"
				@updateCountPagination="onCountPagination"
		></pagination>
		<preload v-if="filterPreloader"></preload>
	</div>
</template>

<script>
import { mapActions } from "vuex";
// components
import SortBtn from "@/shared/SortBtn/SortBtn";
import TableTr from "@/components/Maintenance/Trailers/TrailersForm/Equipment/TableTr/TableTr";
import Preload from "@/shared/Preload/Preload";
import FilterTable
from "@/components/Maintenance/Trailers/TrailersForm/Equipment/FilterTable/FilterTable";
import Pagination from "@/shared/Pagination/Pagination";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
// constants
import { trailerEquipmentsHeader } from "@/constants/defaultHeader";
// helpers
import debounce from "lodash.debounce";
import getUniqId from "@/helper/getUniqId";

export default {
	name: "Equipment",
	components: {
		FilterTable,
		SortBtn,
		TableTr,
		FilterDropDown,
		Pagination,
		Preload
	},
	props: {
		listItems: Array,
		filter: Object,
		getPermissionAction: Boolean,
		isRefresh: String,
		trailerId: Number
	},
	computed: {
		headers() {
			return trailerEquipmentsHeader;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
	},
	watch: {
		listItems(val) {
			this.items = val;
		},
		async isRefresh(val, oldVal) {
			if (val !== oldVal) {
				await this.refreshFilters();
			}
		}
	},
	data: () => ({
		pages: [ 10, 20, 50, 100, 200, 500 ],
		itemsPerPage: 10,
		page: 1,
		pageCount: 0,
		filterUpdate: false,
		sortBy: "id",
		sortDesc: false,
		menu: false,
		filtersMarker: {},
		filters: {},
		filtersList: {},
		list: [],
		checkClasses: {},
		filterPreloader: false,
		isRefreshPage: '',
		uniqId: { key: '', id: '' }
	}),
	methods: {
		...mapActions([ 'onEquipmentListFilterTrailer' ]),
		getWidthMenu(value) {
			if (value === 'options') return 280;
			if (value === 'date') return 300;
			return 330;
		},
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		async refreshFilters() {
			this.sortDesc = false;
			this.sortBy = "id";
			this.items = this.listItems;
			this.page = 1;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}

				this.filters['filter_reviewed'] = 0;
				this.filterUpdate = true;
			}
			this.filterPreloader = true;
			await this.onEquipmentListFilterTrailer({ id: this.trailerId, filters: {} });
			this.filterPreloader = false;
		},
		onEdit(id) {
			this.$emit('updateEdit', id);
		},
		onRemoveItem(id) {
			this.$emit('updateRemoveItem', id);
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		initEquipmentFilter: debounce(async function(filters) {
			await this.onEquipmentListFilterTrailer({ id: this.trailerId, filters });
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		changeSort({ key, value, model }) {
			if (model === 'date') {
				this.filters[key] = value;
				this.filterClasses[key] = !!this.filters[key]['from'];
			} else if (model === 'number') {
				this.filters[key] = value;
				this.filterClasses[key] = !!this.filters[key]['type'];
			} else if (model === 'note') {
				this.filters[key] = value;
				this.filterClasses[key] = !!this.filters[key].length;
			} else if (model === 'options') {
				this.filters[key] = Number(value);
				this.filterClasses[key] = !!this.filters[key].length;
			} else if (model === 'checkbox') {
				this.filters[key] = Number(value);
			} else {
				this.filters[key] = value.map(item => item);
				this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			this.initEquipmentFilter(this.filters);
		},
		toggleOrder(val) {
			switch (val) {
				case 'filter_driver':
					this.sortBy = 'driver';
					break;
				case 'filter_returned':
					this.sortBy = 'returned';
					break;
				case 'filter_returned_date':
					this.sortBy = 'returned_date';
					break;
				case 'filter_receiving_date':
					this.sortBy = 'receiving_data';
					break;
				default:
					this.sortBy = val;
			}

			this.sortDesc = !this.sortDesc;
		},
		getFilterList() {
			this.list = this.listItems;
			for (let i = 0; i < this.headers.length; i++) {
				this.filtersMarker[this.headers[i].value] = true;
				this.$set(this.checkClasses, this.headers[i].value, false);
				const value = this.headers[i].value;

				if (value.startsWith('filter')) {
					this.filters[value] = [];
				}

				this.filtersList[value] = [];
			}
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
	},
	mounted() {
		this.getFilterList();
	}
};
</script>
